import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {map, switchMap} from 'rxjs/operators';
import {ConstanteService} from '../../../_services/constante.service';
import {TerceroUpPasarelaService} from '../../../_services/tercero-up-pasarela.service';
import {SolicitudUnidadCreditoService} from '../../../_services/solicitud-unidad-credito.service';
import {
  SolicitudUnidadCreditoUnidadProductivaService,
} from '../../../_services/solicitud-unidad-credito-unidad-productiva.service';
import {AdmsbConstanteCacheService} from './admsb-constante-cache.service';
import {AdmsbTitularVista} from '../../../_models/admsb-titular';

@Component({
  selector: 'app-admsb-titular',
  templateUrl: './admsb-titular.component.html',
  styleUrls: ['./admsb-titular.component.scss'],
  providers: [{provide: ConstanteService, useClass: AdmsbConstanteCacheService}],
})
export class AdmsbTitularComponent implements OnInit {

  /** Identificador de la pasarela del titular  */
  idTitular: string;

  /** Identificador del tercero titular de la pasarela */
  idTercero: string;

  /** Identificador de la solicitud de unidad de crédito - unidad productiva */
  idSolicitudUCUnidadProductiva: string;

  /** Identificador de la solicitud de unidad de crédito del titular */
  idSolicitudUnidadCredito: string;

  /** Datos del titular emitidos por el encabezado, usados por la sección de contactos */
  titular: AdmsbTitularVista;

  /** Indica que aún no se resolvieron el tercero y las solicitudes de la pasarela */
  cargandoPasarela = true;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private terceroUpPasarelaServicio: TerceroUpPasarelaService,
    private solUnidadCreditoServicio: SolicitudUnidadCreditoService,
    private solUnidadCreditoUPServicio: SolicitudUnidadCreditoUnidadProductivaService,
  ) {
  }

  /**
   * Resuelve desde la pasarela el tercero y las solicitudes que necesitan el encabezado y la
   * sección de unidad productiva, para que la pantalla cargue solo con el identificador de la ruta.
   */
  ngOnInit(): void {
    this.idTitular = this.route.snapshot.paramMap.get('id');

    this.terceroUpPasarelaServicio.obtener(this.idTitular).pipe(
      switchMap(pasarela => {
        this.idTercero = pasarela.idTercero;
        return this.solUnidadCreditoServicio.obtenerPorSolicitudYTercero(pasarela.idSolicitud, pasarela.idTercero).pipe(
          switchMap(solicitudUC => {
            this.idSolicitudUnidadCredito = solicitudUC.idSolicitudUnidadCredito;
            return this.solUnidadCreditoUPServicio.listadoPorSolicitudUC(solicitudUC.idSolicitudUnidadCredito);
          }),
          map(unidadesProductivas => unidadesProductivas
            .find(up => up.idTerceroUnidadProductiva === pasarela.idTerceroUnidadProductiva)),
        );
      }),
    ).subscribe({
      next: unidadProductiva => {
        this.idSolicitudUCUnidadProductiva = unidadProductiva?.idSolicitudUCUnidadProductiva;
        this.cargandoPasarela = false;
      },
      error: () => this.cargandoPasarela = false,
    });
  }

  regresar(): void {
    this.location.back();
  }

}
